module.exports = __webpack_public_path__ + "img/RaphaelPicture1.f36d8074.jpg";